import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import OptionContainer from 'ui-library/menus/OptionContainer';

interface Props {
  buttonStyle: ButtonStyle;
  className?: string;
  expanded: boolean;
}

interface State {
  isOpen: boolean;
}

class ToggleDropdown extends React.Component<Props, State> {
  static defaultProps = {
    buttonStyle: ButtonStyle.TERTIARY_WHITE,
  };

  override state: State = {isOpen: false};

  _handleUnexpand = (): void => {
    SidepanelActions.unexpand();
  };

  _handleExpand = (): void => {
    SidepanelActions.expand();
  };

  _handleClose = (): void => {
    SidepanelActions.close();
  };

  _handleMouseOver = (): void => {
    this.setState({isOpen: true});
  };

  _handleMouseLeave = (): void => {
    this.setState({isOpen: false});
  };

  _handleToggle = (isOpen: boolean): void => {
    // If the user moves too quickly over the dropdown, mouseOver is triggered but mouseLeave is not since
    // the menu has rendered. To fix, allow Dropdown to also control the toggle (e.g. on outside click).
    this.setState({isOpen});
  };

  override render(): JSX.Element {
    return (
      <Dropdown
        isOpen={this.state.isOpen}
        onToggle={this._handleToggle}
        menu={
          <Menu
            className={css(styles.menu)}
            height={Menu.HEIGHTS.SMALL}
            onMouseLeave={this._handleMouseLeave}
          >
            {this.props.expanded ? (
              <OptionContainer onSelect={this._handleUnexpand}>
                <BenchlingIcon altText="Collapse" className={css(styles.icon)} icon="chevron-left" />
              </OptionContainer>
            ) : (
              <OptionContainer onSelect={this._handleExpand}>
                <BenchlingIcon altText="Expand" className={css(styles.icon)} icon="chevron" />
              </OptionContainer>
            )}
            <OptionContainer onSelect={this._handleClose}>
              <BenchlingIcon altText="Close" className={css(styles.icon)} icon="panel-hidden" />
            </OptionContainer>
          </Menu>
        }
      >
        <Button
          buttonStyle={this.props.buttonStyle}
          className={this.props.className}
          icon={this.props.expanded ? 'chevron-left' : 'chevron'}
          onClick={this.props.expanded ? this._handleUnexpand : this._handleExpand}
          onMouseOver={this._handleMouseOver}
          size={ButtonSize.SMALL}
        />
      </Dropdown>
    );
  }
}

export default ToggleDropdown;

const styles = StyleSheet.create({
  menu: {
    top: -2,
  },
  icon: {
    color: Colors.GRAY_DARKER,
    margin: 10,
  },
});
